import { useGetLoanTransactionsQuery } from "@/modules/loan/services";
import { AppPaths } from "@/shared/common/enums";
import { HistoryDetail, SeeMore } from "@/shared/components";
import { buildRoute, getFormattedHistoryList } from "@/shared/helpers";
import { Heading } from "@ab.uitools/ui-library/components/Heading";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

interface Props {
  id: string | number;
  loanId: string;
}

export const LoanDetailHistory = ({ id = "", loanId }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { data: loanHistory, isFetching } = useGetLoanTransactionsQuery(
    { id },
    {
      refetchOnMountOrArgChange: true,
    }
  );

  const handleSeeMore = () => {
    const url = buildRoute(AppPaths.LoanHistory, { loanId, id });
    navigate(url);
  };

  const historyList = useMemo(() => {
    return getFormattedHistoryList({
      list: loanHistory ?? [],
    });
  }, [loanHistory]);

  return (
    <div className="mt-40">
      <div className="flexbox align-items--center">
        <Heading className="content-title" size="xsmall" weight="bolder">
          {t("loans.loanHistory")}
        </Heading>
        <SeeMore action={handleSeeMore} className="ml-8 mt-4"/>
      </div>
      <HistoryDetail
        isFetching={isFetching}
        historyList={historyList}
      />
    </div>
  );
};
